import { S3_DIRECTORY_NAMES } from '@/constants/accessor/s3/directoryName'
import { INSPECTION_CARD_TYPE } from '@/constants/ui/inspection/common/inspectionCardType'
import {
  roofTileOptions,
  windowOptions,
  exteriorWetMaterialOptions,
  exteriorDryMaterialOptions,
  signboardOptions,
  outdoorStairsOptions,
  otherItemOptions,
  roofMaterialOptions
} from '@/constants/ui/inspection/step2/step2Card/fallingSelectOptions'

export const roofTile = {
  title: '瓦',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: roofTileOptions,
  key: S3_DIRECTORY_NAMES.ROOF_TILE
}

export const windowFrame = {
  title: '窓枠・窓ガラス',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: windowOptions,
  key: S3_DIRECTORY_NAMES.WINDOW_FRAME
}

export const exteriorWetMaterial = {
  title: '外装材　湿式の場合',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: exteriorWetMaterialOptions,
  key: S3_DIRECTORY_NAMES.EXTERIOR_WET_MATERIAL
}

export const exteriorDryMaterial = {
  title: '外装材　乾式の場合',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: exteriorDryMaterialOptions,
  key: S3_DIRECTORY_NAMES.EXTERIOR_DRY_MATERIAL
}

export const exteriorWetMaterialRC = {
  title: '外装材(モルタル・タイル・石貼り等)',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: exteriorWetMaterialOptions,
  key: S3_DIRECTORY_NAMES.EXTERIOR_WET_MATERIAL
}

export const exteriorDryMaterialRC = {
  title: '外装材(ALC板・PC板・金属・ブロック等)',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: exteriorDryMaterialOptions,
  key: S3_DIRECTORY_NAMES.EXTERIOR_DRY_MATERIAL
}

export const signboard = {
  title: '看板・機器類',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: signboardOptions,
  key: S3_DIRECTORY_NAMES.SIGNBOARD
}

export const outdoorStairs = {
  title: '屋外階段',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: outdoorStairsOptions,
  key: S3_DIRECTORY_NAMES.OUTDOOR_STAIRS
}

export const otherItem = {
  title: 'その他',
  pattern: INSPECTION_CARD_TYPE.TYPE_A,
  inputSelectOption: otherItemOptions,
  key: S3_DIRECTORY_NAMES.OTHER_ITEM
}

export const roofMaterial = {
  title: '屋根材',
  pattern: INSPECTION_CARD_TYPE.COMMON,
  inputSelectOption: roofMaterialOptions,
  key: S3_DIRECTORY_NAMES.ROOF_MATERIAL
}
